module.exports = __webpack_public_path__ + "img/015-donation-7.ce684484.svg";